import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './AccordionSection.css';

export default function AccordionSection({ title, children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="accordion-section">
            <div className="accordion-header" onClick={() => setOpen(!open)}>
                <h2>{title}</h2>
                <FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} className="accordion-icon" />
            </div>
            {open && <div className="accordion-content">{children}</div>}
        </div>
    );
}
